import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class DateOfBirthValidator {
    static MIN_AGE: number = 12;
    static MAX_AGE: number = 100;

    static validate(error: ValidationErrors): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }

            // test the age from the date of birth
            const valid = this.validateAge(new Date(control.value));

            // if true, return no error (no error), else return error passed in the second parameter
            return valid ? null : error;
        };
    }

    private static validateAge(dateOfBirth: Date): boolean {
        const age = this.calculateAge(dateOfBirth);
        return age >= this.MIN_AGE && age <= this.MAX_AGE;
    }

    private static calculateAge(dateOfBirth: Date): number {
        const diff = Date.now() - dateOfBirth.getTime();
        const ageDate = new Date(diff);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }
}
